<template>
    <div id="documents">
        <!--Devis-->
        <div id="devis" class="typeDocument">
          <div v-if="proposals.length">
            <b-table class="text-center" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFilteredProposals" responsive :striped="true" :fields="fieldsDevis" :items="proposals" :current-page="currentPageDevis" :per-page="perPage">
              <template v-slot:cell(date-creation)="data">
                <span style='font-size:14px;'>{{ data.item.date_creation }}</span>
              </template>
              <template v-slot:cell(reference)="data">
                <span style='width:30%; font-size:14px; text-transform: uppercase;'>{{ data.item.ref_client }}</span>
              </template>
              <template v-slot:cell(prix-ht)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.total_ht }}</span>
              </template>
              <template v-slot:cell(prix-ttc)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.total_ttc }}</span>
              </template>
              <template v-slot:cell(etat)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.statut_libelle }}</span>
              </template>
              <template v-slot:cell(document)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.ref+'.pdf' }}</span>
              </template>
              <template v-slot:cell(download)="data">
                <a v-bind:href="'/api/downloadDoc/'+data.item.last_main_doc" download><span style="cursor:pointer;" class='fas fa-cloud-download-alt' v-b-tooltip.hover title='Télécharger'></span></a>
              </template>
              <template v-slot:cell(visual)="data">
                <a v-on:click.stop="visualDocClient(data.item)"><span style="cursor:pointer;" class='far fa-eye' v-b-tooltip.hover title='Visualiser'></span></a>
              </template>
              <!--<template v-slot:cell(comment)="data">
                <a v-on:click.stop="commentDoc(data.item.last_main_doc)"><span style="cursor:pointer;" class='fas fa-comment-alt' v-b-tooltip.hover title='Commentaire'></span>
              </template>-->
            </b-table>
            <div v-if="proposals.length>perPage">
              <b-pagination size="md" :total-rows="proposals.length" v-model="currentPageDevis" :per-page="perPage" />
            </div>
          </div>
          <div v-else>
            <h5>Aucuns devis disponibles</h5>
          </div>
        </div>
      
      <b-modal id="modalVisualDevis" @hide="resetModal" :title="modalVisual.title" hide-footer>
        <template>
          <iframe id="visualDoc" v-bind:src="visualSrc"></iframe>
        </template>
      </b-modal>
    </div>
  </template>
  
  <style>
  #documents{
    margin: auto;
    width: 100%;
    text-align: center;
  }
  
  #contrat > h3, #contrat .table thead th, #contrat .table td,#contrat .table th{
    border-color: #3C4694;
  }
  
  #devis > h3, #devis .table thead th, #devis .table td,#devis .table th{
    border-color: #6D3D94;
  }
  
  #commande > h3, #commande .table thead th, #commande .table td,#commande .table th{
    border-color: #ED2C74;
  }
  
  #facture > h3, #facture .table thead th, #facture .table td,#facture .table th{
    border-color: #00B7A7;
  }
  
  #documents .input-group{
    width: 60%;
  }
  
  #documents .input-group>.form-control{
    flex: 1 1 50%;
  }
  
  #visualDoc{
    width: 100%;
    height: 100%;
  }
  
  #modalVisualDevis .modal-dialog {
    max-width: 50%;
    height: 95%;
    margin-top: 1%;
  }
  
  #modalVisualDevis .modal-body {
    max-height: 90%;
    padding: 0;
    overflow: unset;
  }
  
  #modalVisualDevis .modal-dialog > div{
    height: 100%;
  }
  
  </style>
  
  <script>
  import script from '../../../script/script.js';
  
  export default {
    data() {
      return {
        post: {},
        fieldsDevis:[{key:"date-creation", label:"Date de création"},{key:"reference", label:"Référence"},{key:"prix-ht", label:"Total(ht*)"},{key:"prix-ttc", label:"Total(ttc*)"},{key:"etat", label:"Etat"},{key:"document", label:"Document"},{key:"download", label:""},{key:"visual", label:""}/*,{key:"comment", label:""}*/],
        currentPageDevis: 1,
        perPage: 10,
        totalRows:{
          contracts:0,
          orders:0,
          proposals:0,
          invoices:0,
        },
        modalVisual: { title: '', content: '' },
        visualSrc:''
      }
    },
    mounted:function(){
      this.$store.commit("resetDocuments")
      this.loadDocuments("proposals");
    },
    methods: {
      loadDocuments: script.loadDocuments,
      visualDocClient: script.visualDocClient,
      commentDoc: script.commentDoc,
    },
    components: {
  
    },
    computed: {
      proposals(){
        return this.$store.state.proposals
      },
    }
  }
  </script>
  